export const firebaseConfig = {
  apiKey: "AIzaSyBqiMaXDh_Tsb8WSiUJEVNpwfWiEzE9TaU",
  authDomain: "model-space-158da.firebaseapp.com",
  databaseURL: "https://model-space-158da.firebaseio.com",
  projectId: "model-space-158da",
  storageBucket: "model-space-158da.appspot.com",
  messagingSenderId: "1281374062",
  appId: "1:1281374062:web:18d22fbf18c944e579f37f",
  measurementId: "G-L2LDDS2SX7"
}